import axios from 'axios';
import { API_BASEURL } from 'utils/constants';

export const request = axios.create({ baseURL: API_BASEURL });
